import { ProductBuilderMachineContext, BaseProduct } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetStackSideOptions = (context: ProductBuilderMachineContext) => string[];
type ProductHasStackSide = (
  stackSide: string,
) => (product: BaseProduct) => boolean;

export const getStackSideOptions: GetStackSideOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { stack_side },
  } = baseProduct;
  return stack_side ? stack_side : [];
};

export const productHasStackSide: ProductHasStackSide = stackSide => ({
  metafields: { stack_side },
}) => {
  if (!stack_side) return true;
  return stack_side.some(option => option === stackSide);
};
